module.exports = __webpack_public_path__ + "media/application/images/icons/quote-large-12ee0332e5ce8ac7aff1ce8af73ce39d.svg";